module.exports = {
  __depends__: [ require(106), require(155) ],
  __init__: [ 'bendpoints', 'bendpointSnapping' ],
  bendpoints: [ 'type', require(95) ],
  bendpointMove: [ 'type', require(92) ],
  bendpointSnapping: [ 'type', require(93) ]
};